import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SdbWithLove from "../../../../components/atoms/SdbWithLove/index.js";
import LogoutButton from "../../../../components/atoms/LogoutButton/index.js";
import { Footer, FooterInner } from "../ProfileMenu.components.js";
export const ProfileMenuFooterComponent = ({ withLove, logoutButtonProps, ...props }) => {
    const withLogout = !!logoutButtonProps;
    if (!withLogout && !withLove) {
        return null;
    }
    return (_jsx(Footer, { "data-testid": "ProfileMenuFooter", ...props, children: _jsxs(FooterInner, { children: [withLove && _jsx(SdbWithLove, {}), withLogout && _jsx(LogoutButton, { ...logoutButtonProps })] }) }));
};
export default ProfileMenuFooterComponent;
